export const HIERARCHY_LEADERSHIP_TITLE = 'Sua Liderança';

export const HIERARCHY_ORIGIN_LABELS: Record<string, string> = {
  HIERARCHY_CASCADE: 'Repasse de hierarquia',
};
